import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const SLIDES = [
  '/media/founder/Untitled_design.jpg',
  '/media/founder/2_-_Copy.jpg',
  '/media/founder/IMG_7119.jpg',
  '/media/founder/Untitled_design__1_.jpg',
  '/media/founder/IMG-1647.jpg',
  '/media/founder/National_Channel_Zee_News_पर_BJP_spokesperson_Prem_Shukla_JI_क__स_थ_Vivek_Mudgal__.jpeg',
  '/media/founder/IMG-3548.JPG',
  '/media/founder/IMG-4602.JPG',
  '/media/founder/IMG-0468.JPG',
];

export default function BannerSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % SLIDES.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const prev = () => setCurrent(p => (p - 1 + SLIDES.length) % SLIDES.length);
  const next = () => setCurrent(p => (p + 1) % SLIDES.length);

  return (
    <section className="relative w-full overflow-hidden bg-[#0a0515]" data-testid="banner-slider">
      <div className="relative w-full h-[280px] sm:h-[350px] md:h-[420px] lg:h-[480px]">
        {SLIDES.map((src, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
          >
            <img
              src={src}
              alt={`Vivek Mudgal Astrologer ${i + 1}`}
              className="w-full h-full object-contain"
            />
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center hover:bg-black/60 transition-colors" data-testid="slider-prev">
        <ChevronLeft className="w-5 h-5 text-white" />
      </button>
      <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center hover:bg-black/60 transition-colors" data-testid="slider-next">
        <ChevronRight className="w-5 h-5 text-white" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all ${i === current ? 'bg-gold w-8' : 'bg-white/40 hover:bg-white/60'}`}
            data-testid={`slider-dot-${i}`}
          />
        ))}
      </div>
    </section>
  );
}
